/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_Reason_Multiple_PeopleInputs */

const en_us2_body_assessment_pose_reason_multiple_people = /** @type {(inputs: Body_Assessment_Pose_Reason_Multiple_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More than one person showed up in the photo. Be alone in it, with nobody behind or beside you.`)
};

const pt_br2_body_assessment_pose_reason_multiple_people = /** @type {(inputs: Body_Assessment_Pose_Reason_Multiple_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apareceu mais de uma pessoa na foto. Fique sozinho, sem ninguém atrás nem ao lado.`)
};

const es_419_body_assessment_pose_reason_multiple_people = /** @type {(inputs: Body_Assessment_Pose_Reason_Multiple_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apareció más de una persona en la foto. Que solo estés tú, sin nadie detrás ni al lado.`)
};

const pt_pt2_body_assessment_pose_reason_multiple_people = /** @type {(inputs: Body_Assessment_Pose_Reason_Multiple_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apareceu mais de uma pessoa na foto. Fica sozinho, sem ninguém atrás nem ao lado.`)
};

const fr_fr2_body_assessment_pose_reason_multiple_people = /** @type {(inputs: Body_Assessment_Pose_Reason_Multiple_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus d'une personne apparaît sur la photo. Personne d'autre que toi, ni derrière ni à côté.`)
};

const de_de2_body_assessment_pose_reason_multiple_people = /** @type {(inputs: Body_Assessment_Pose_Reason_Multiple_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf dem Foto war mehr als eine Person. Sei allein darauf, niemand hinter oder neben dir.`)
};

const it_it2_body_assessment_pose_reason_multiple_people = /** @type {(inputs: Body_Assessment_Pose_Reason_Multiple_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nella foto c'era più di una persona. Devi essere da solo, senza nessuno dietro o accanto.`)
};

/**
* | output |
* | --- |
* | "More than one person showed up in the photo. Be alone in it, with nobody behind or beside you." |
*
* @param {Body_Assessment_Pose_Reason_Multiple_PeopleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_reason_multiple_people = /** @type {((inputs?: Body_Assessment_Pose_Reason_Multiple_PeopleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_Reason_Multiple_PeopleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_reason_multiple_people(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_reason_multiple_people(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_reason_multiple_people(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_reason_multiple_people(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_reason_multiple_people(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_reason_multiple_people(inputs)
	return en_us2_body_assessment_pose_reason_multiple_people(inputs)
});
export { body_assessment_pose_reason_multiple_people as "body-assessment.pose_reason.multiple_people" }